export default "__VITE_ASSET__BNPh8$nH__"